
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 .5a6.257 6.257 0 00-6.25 6.25A6.257 6.257 0 0012 13a6.257 6.257 0 006.25-6.25A6.257 6.257 0 0012 .5zm0 10a3.755 3.755 0 01-3.75-3.75A3.755 3.755 0 0112 3a3.755 3.755 0 013.75 3.75A3.755 3.755 0 0112 10.5zm11.25 13.75V23c0-4.824-3.926-8.75-8.75-8.75h-5C4.675 14.25.75 18.176.75 23v1.25h2.5V23a6.257 6.257 0 016.25-6.25h5A6.257 6.257 0 0120.75 23v1.25h2.5z","fill":"#8D16C1"}})])
          )
        }
      }
    